export default __webpack_public_path__ + "static/media/dashboard-light.74ee3ea2.jpg";